import { useEffect } from 'react';
import { BrowserRouter, Routes as Rotas, Route, } from 'react-router-dom';
import RequireAuth from '../helpers/RequireAuth'
import { useAuth } from '../contexts/auth.context';

import InitalPage from '../pages/index'
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Evento from '../pages/Evento';
import Financeiro from '../pages/Financeiro';
import Inscritos from '../pages/Inscritos';
import Config from '../pages/Config';
import Politicas from '../pages/Config/Politicas';
import Certidoes from '../pages/Certidoes';
import Payment from '../pages/Financeiro/Payment'
import Frequencia from '../pages/Frequencia';
import Affiliates from '../pages/Afiliados';
import FinanceiroAfiliados from '../pages/FinanceiroAfiliados';
import GuestsPage from '../pages/Guests';
import EventPresentations from '../pages/EventPresentations'
import SortedConfig from '../pages/Sorted/SortedConfig';
import SortedDraw from '../pages/Sorted/SortedDraw';
import Relatorios from '../pages/Relatorios';
import Crachas from '../pages/Crachas';
import InscricaoRapida from '../pages/InscricaoRapida';

import EventForm from '../pages/Evento/StepAddEvent/index';
import EditForm from '../pages/Evento/StepEditEvent/index';
import updateFavicon from '../helpers/FaviconUpdate';

import Sair from '@mui/icons-material/Logout';
import Dash from '@mui/icons-material/Dashboard';
import Event from '@mui/icons-material/Event';
import LocalAtm from '@mui/icons-material/LocalAtm';
import People from '@mui/icons-material/People';
import Engineering from '@mui/icons-material/Engineering';
import PostAdd from '@mui/icons-material/PostAdd'
import Checklist from '@mui/icons-material/Rule';
import LocalHotel from '@mui/icons-material/LocalHotel';
import LibraryBooks from '@mui/icons-material/LibraryBooks'
import Groups from '@mui/icons-material/Groups';
import Casino from '@mui/icons-material/Casino';
import Analytics from '@mui/icons-material/Analytics';
import AccountBalance from '@mui/icons-material/AccountBalance';
import Policy from '@mui/icons-material/Policy';
import PersonAdd from '@mui/icons-material/PersonAdd';



export const stack = [
  { path: 'Dashboard', screen: <Dashboard />, icon: <Dash /> },
  { path: 'Eventos', screen: <Evento />, icon: <Event /> },
  { path: 'Materiais', screen: <EventPresentations />, icon: <LibraryBooks /> },
  { path: 'Financeiro', screen: <Financeiro />, icon: <LocalAtm /> },
  { path: 'Relatorios', screen: <Relatorios />, icon: <Analytics /> },
  { path: 'Filiados', screen: <Affiliates />, icon: <Groups /> },
  { path: 'FinanceiroAfiliados', screen: <FinanceiroAfiliados />, icon: <AccountBalance /> },
  { path: 'Sorteios', screen: <SortedConfig/>, icon: <Casino/>},
  { path: 'SorteioRealizacao', screen: <SortedDraw/>, icon: <Casino/>},
  { path: 'Inscritos', screen: <Inscritos />, icon: <People /> },
  { path: 'InscricaoRapida', screen: <InscricaoRapida />, icon: <PersonAdd /> },
  { path: 'Hospedagem', screen: <GuestsPage />, icon: <LocalHotel /> },
  { path: 'Documentos', screen: <Certidoes />, icon: <PostAdd /> },
  { path: 'Frequencia', screen: <Frequencia />, icon: <Checklist /> },
  { path: 'Politicas', screen: <Politicas />, icon: <Policy /> },
  { path: 'Ajustes', screen: <Config />, icon: <Engineering /> },
  { path: 'Crachas', screen: <Crachas />, icon: <PostAdd /> },
  { path: 'Logout', icon: <Sair /> }
]

export const Routes = () => {
  const { setBasePath } = useAuth();
  const allowedPaths = ["agip", "apeprev","semper"];
  const currentBase = window.location.pathname.split('/')[1];
  console.log( currentBase )
  const baseName = allowedPaths.includes(currentBase) ? `/${currentBase}` : "/agip";

  useEffect(() => {
    if (allowedPaths.includes(currentBase)) {
      setBasePath(currentBase);
      updateFavicon(currentBase)
    } 
  }, [currentBase]);



  return (
    <BrowserRouter basename={baseName}>
      <Rotas>
        <Route index element={<Login />} />
        {stack.map(item =>
          <Route path={`${item.path}`} key={item.path} element={
            <RequireAuth>
              <InitalPage title={item.path} screen={item.screen} />
            </RequireAuth>
          }
          />
        )}
        <Route path={"event/add"} element={
          <RequireAuth>
            <InitalPage screen={<EventForm />} />
          </RequireAuth>
        }
        />
        <Route path={"financeiro/payment"} element={
          <RequireAuth>
            <InitalPage screen={<Payment />} />
          </RequireAuth>
        }
        />
        <Route path={"event/edit/:eventId"} element={
          <RequireAuth>
            <InitalPage screen={<EditForm />} />
          </RequireAuth>
        }
        />
         <Route path={"SorteioRealizacao"} element={
          <RequireAuth>
            <InitalPage screen={<SortedDraw />} />
          </RequireAuth>
        }
        />
      </Rotas>
    </BrowserRouter>
  )
};